<template>
  <page-wrapper :title="title" :hasPad="true">
    <div class="d-flex justify-content-between">
      <div>
        <sc-button
          v-bind:disabled="isViewOnlyByRole"
          variant="secondary"
          @click="handleClickDuplicate"
        >สร้างแพ็กเกจโดยอ้างอิงจากแพ็กเกจนี้</sc-button>
        <sc-button
          variant="secondary"
          @click="handleClickDownloadReport"
        >Download Report</sc-button>
      </div>
      <div>
        <sc-button
          v-if="isShowExportRegistrationFormButton"
          variant="primary"
          @click="handleClickExportRegistrationFormButton"
        >Export ข้อมูล Registration Form</sc-button>
        <language-select
          v-model="language"
          @change="handleChangeLanguage"
        ></language-select>
      </div>
    </div>
    <div class="wrapper">
      <package-editor
        v-model="form"
        :imageUrl="imageUrl"
        :thumbnailUrl="thumbnailUrl"
        :targets="targets"
        :sellerTradeParties="sellerTradeParties"
        :paymentCampaigns="paymentCampaigns"  
        :disabled="isViewOnlyByRole"
        :isDisabledByLanguageNotTH="isDisabledByLanguageNotTH"
        :isDisabledByEditPackage=true
        @changedHasOptionPackage="handleSetupPricings"
        @selectedService="handleSetupPricings"
      ></package-editor>
      <div class="d-flex justify-content-between mt-4" v-if="!isViewOnlyByRole">
        <sc-button variant="danger" @click="handleClickRemove">ลบ</sc-button>
        <sc-button variant="primary" @click="handleClickSave">บันทึก</sc-button>
      </div>
    </div>
    <confirm
      name="exportModal"
      v-show="exportDialog.isShow"
      @confirm="handleConfirm"
      :data="exportDialog.data"
    >
      <div class="mb-4 text-left" style="width: 350px; max-width: 100%;">
        <label class="label">ประเภท</label>
        <el-select v-model="exportType" class="w-100">
          <el-option value="xlsx" label="Microsoft Excel (.xlsx)"></el-option>
          <el-option value="zip" label="PDF (.zip)"></el-option>
        </el-select>
      </div>
      <template>
        <div class="text-left">
          <label class="label">ช่วงเวลา</label>
        </div>
        <date-picker v-model="exportForm" type="daterange"></date-picker>
      </template>
    </confirm>
  </page-wrapper>
</template>

<script>
import { Select as ElSelect, Option as ElOption } from "element-ui";
import PageWrapper from "@/lib/components/PageWrapper";
import ScButton from "@/lib/components/ScButton";
import LanguageSelect from "@/lib/components/LanguageSelect";
import PackageEditor from "../components/PackageEditor";
import { baanRueJaiClient } from "@/dependencies";
import { uploadPublicImage } from "@/god";
import { toCamelCaseObject } from "@/lib/util";
import { localization } from "@/lib/mapper";
import DatePicker from "@/lib/components/DatePicker";
import { isNil, isEmpty, head, tail } from "ramda";
import { toOptionalDateTime, toOptionalISOString } from '@/lib/dateTime';
import {
  convertStangToBathAndRoundTwoDecimal,
  convertBathToStangAndRoundTwoDecimal
} from "@/lib/formatter";

export default {
  components: {
    PageWrapper,
    ScButton,
    LanguageSelect,
    PackageEditor,
    DatePicker,
    ElSelect,
    ElOption
  },
  data() {
    const title = "รายละเอียดแพ็กเกจ";
    const form = {
      id: null,
      name: "",
      receiptName: "",
      target: "สำหรับบ้าน",
      price: 0,
      pricings: [],
      billingCycle: 1,
      detail: "",
      termsAndConditions: "",
      sellerTradePartyId: null,
      services: [],
      projects: [],
      homes: [],
      imageFile: null,
      thumbnailFile: null,
      is_secret: false,
      is_expire_after_appointment: false,
      noteLabel: null,
      originalPrice: null,
      packageCollection: null,
      purchaseSuccessTitle: null,
      purchaseSuccessMessage: null,
      expiredAt: null,
      isReadonlyPackage: true,
      maximumQuantity: 0,
      minimumQuantity: 0,
      packageOptions: null,
      packageAlbums: [],
      coinAmountPercent: null,
      coinAmountFix: null,
      keywords: null,
      paymentCampaignIds: [],
      isNotSendReceipt: false
    };

    const imageUrl = null;
    const targets = [];
    const thumbnailUrl = null;
    const sellerTradeParties = [];
    const paymentCampaigns = [];

    const permission = JSON.parse(localStorage.getItem("adminRolePermission")) || null;

    return {
      title,
      form,
      imageUrl,
      targets,
      thumbnailUrl,
      sellerTradeParties,
      paymentCampaigns,
      exportDialog: {
        isShow: false,
        data: {
          title: "Export Registration Form",
          buttonCancel: "ยกเลิก",
          buttonSubmit: "ยืนยัน"
        }
      },
      exportForm: [],
      exportType: "xlsx", // xlsx | zip
      language: localization.TH,
      newOptionVariantPrices: [],
      newServicePrices: [],
      permission
    };
  },
  computed: {
    isEditorDisabled() {
      return this.$isCallCenter;
    },
    isDisabledByLanguageNotTH() {
      return this.language !== localization.TH
    },
    exportQuery() {
      const [from, to] = this.exportForm;

      return {
        start_at: from.toISO(),
        end_at: to.toISO()
      };
    },
    isShowExportRegistrationFormButton() {
      return this.form.registrationForm;
    },
    isViewOnlyByRole() {
      const roles = ["AC","CC"]
      return roles.includes(this.permission.role)
    }
  },
  watch: {
    form(form, oldForm) {
      if (this.form.imageFile !== oldForm.imageFile) {
        this.imageUrl = this.form.imageFile;
      }

      if (this.form.thumbnailFile !== oldForm.thumbnailFile) {
        this.thumbnailUrl = URL.createObjectURL(this.form.thumbnailFile);
      }

      if (!isNil(this.form.registrationForm)) {
        this.form.registrationForm.sections.map(section => {
          section.inputs.map(input => {
            input.watermarkUrl = !isNil(input.watermarkFile)
              ? URL.createObjectURL(input.watermarkFile)
              : input.watermarkUrl
          })
        })
      }
    }
  },
  created() {
    this.setup();
  },
  methods: {
    setup() {
      this.setupData();
    },
    setupData() {
      this.setupTargets();
      this.setupSellerTradeParties();
      this.setupPaymentCampaigns();
      this.setupForm();
    },
    async setupTargets() {
      const targets = await this.fetchTargets();

      this.targets = targets;
    },
    async setupSellerTradeParties() {
      const sellerTradeParties = await this.fetchSellerTradeParties();

      this.sellerTradeParties = sellerTradeParties;
    },
    async setupPaymentCampaigns() {
      const paymentCampaigns = await this.fetchPaymentCampaigns();

      this.paymentCampaigns = paymentCampaigns;
    },
    async setupForm() {
      const data = await this.fetchData();

      const {
        id,
        name,
        receipt_name: receiptName,
        detail,
        target,
        price,
        pricings,
        billing_cycle: billingCycle,
        terms_and_conditions: termsAndConditions,
        seller_trade_party_id: sellerTradePartyId,
        image_url: imageUrl,
        services,
        projects,
        homes,
        thumbnail_url: thumbnailUrl,
        is_secret: isSecret,
        is_expire_after_appointment: isExpireAfterAppointment,
        note_label: noteLabel,
        registration_form: registrationForm,
        subpackages,
        superpackages,
        purchasing_limit: purchasingLimit,
        original_price: originalPrice,
        purchase_success_title: purchaseSuccessTitle,
        purchase_success_message: purchaseSuccessMessage,
        expired_at: expiredAt,
        maximum_quantity: maximumQuantity,
        minimum_quantity: minimumQuantity,
        package_options: packageOptions,
        expire_duration: expireDuration,
        package_albums: packageAlbums,
        coin_amount_percent: coinAmountPercent,
        coin_amount_fix: coinAmountFix,
        package_tags: packageTags,
        advance_notice_duration: advanceNoticeDuration,
        advance_notice_message: advanceNoticeMessage,
        is_ignore_count_coupon: isIgnoreCountCoupon,
        payment_campaign_ids: paymentCampaignIds,
        is_required_issue_receipt : isRequiredIssueReceipt,
      } = data;

      const newPackageOptions = await this.setupPackageOptionsDividePrice(packageOptions);
      const hasAdvanceNotice = advanceNoticeDuration ? true : false;

      let allImageToAlbum = []
      if (imageUrl && (!packageAlbums || packageAlbums.length === 0)) {
        allImageToAlbum = [imageUrl]
      } else if (
        packageAlbums
        && packageAlbums.length > 0
        && imageUrl
      ) {
        allImageToAlbum = packageAlbums
        allImageToAlbum.unshift(imageUrl)
      }

      let coinAmountStatus = "no"
      if (coinAmountPercent) {
        coinAmountStatus = "percent"
      } else if (coinAmountFix) {
        coinAmountStatus = "fix"
      }

      this.form = {
        id: id,
        name,
        receiptName,
        detail,
        target,
        price: convertBathToStangAndRoundTwoDecimal(price),
        pricings: toCamelCaseObject(pricings),
        originalPrice: originalPrice !== null
          ? convertBathToStangAndRoundTwoDecimal(originalPrice)
          : null,
        billingCycle,
        termsAndConditions,
        sellerTradePartyId,
        services: services.map(service => ({
          ...service,
          iconUrl: service.icon_url,
          provider: {
            ...service.provider,
            logoUrl: service.provider.logo_url
          }
        })),
        projects: projects.map(project => ({
          ...project,
          projectId: project.project_id
        })),
        homes: homes.map(home => ({
          ...home
        })),
        imageFile: null,
        thumbnailFile: null,
        isSecret,
        isExpireAfterAppointment,
        noteLabel,
        registrationForm: toCamelCaseObject(registrationForm),
        superpackages: !isEmpty(superpackages)
          ? superpackages.map(item => item.id)
          : null,
        subpackages: !isEmpty(subpackages)
          ? subpackages.map(item => item.id)
          : null,
        packageCollection: !isEmpty(subpackages)
          ? subpackages.map(item => item.id).toString()
          : null,
        hasOptionPackage: !isEmpty(pricings),
        purchasingLimit,
        purchaseSuccessTitle,
        purchaseSuccessMessage,
        expiredAt: toOptionalDateTime(expiredAt),
        maximumQuantity,
        minimumQuantity: minimumQuantity !== null
          ? minimumQuantity
          : 1,
        packageOptions: newPackageOptions,
        isReadonlyPackage: true,
        newOptionVariantPrices: this.newOptionVariantPrices,
        newServicePrices: this.newServicePrices,
        isReadOnlyOptionPrice: false,
        expireDuration,
        packageAlbums,
        allImageToAlbum,
        coinAmountPercent,
        coinAmountFix,
        coinAmountStatus,
        keywords: packageTags,
        hasAdvanceNotice,
        advanceNoticeDuration,
        advanceNoticeMessage,
        isIgnoreCountCoupon,
        paymentCampaignIds,
        isRequiredIssueReceipt,
        isNotSendReceipt : !isRequiredIssueReceipt
      };
      this.imageUrl = imageUrl;
      this.thumbnailUrl = thumbnailUrl;
    },
    async fetchData() {
      const { id } = this.$route.params;

      const response =
        this.language === localization.TH
          ? await baanRueJaiClient.admin.subscriptions.recommend_packages.get(
              id
            )
          : await baanRueJaiClient.admin.subscriptions.recommend_packages.getLocalization(
              id,
              this.language
            );

      return response.data.result;
    },
    getOptions(services) {
      const options = !isEmpty(services)
        ? services.flatMap(service =>
            service.options.map(option =>
              option.variants.map(variant => ({
                service: service.name,
                option: option.title,
                variant: variant.title,
                isSale: variant.is_sale
              }))
            )
          )
        : [];

      return options;
    },
    fetchTargets() {
      return Promise.resolve([
        { id: "0", name: "สำหรับบ้าน" },
        { id: "1", name: "สำหรับคอนโด" },
        { id: "2", name: "สำหรับบ้านขนาดใหญ่" }
      ]);
    },
    async fetchSellerTradeParties() {
      const response = await baanRueJaiClient.admin.subscriptions.receipts.getSellerTradeParties();

      return response.data.result;
    },
    async fetchPaymentCampaigns() {
      const response = await baanRueJaiClient.admin.payment.getPaymentCampaigns();

      return response.data.result;
    },
    setupPricings(options) {
      const pricingPatterns = this.createPricingPatterns(options);

      this.form.pricings = !isEmpty(pricingPatterns)
        ? pricingPatterns.map(pattern => ({
            variants: pattern,
            isSell: true,
            isSale: false,
            originalPrice: null,
            price: 0
          }))
        : [];
    },
    createPricingPatterns(options) {
      if (isEmpty(options)) {
        return [];
      }

      if (options.length === 1) {
        return head(options).map(subOption => [subOption]);
      } else if (options.length >= 1) {
        const firstOption = head(options);
        const otherOptions = tail(options);
        const patternOptions = this.createPricingPatterns(
          otherOptions
        ).flatMap(subOtherOption =>
          firstOption.map(subOption => [subOption, ...subOtherOption])
        );

        return patternOptions;
      }
    },
    async handleClickSave() {
      try {
        if (!this.form.price) {
          alert("กรุณาใส่ราคา แพ็กเกจ");
          return;
        }

        if (
          this.form.coinAmountPercent &&
          (this.form.coinAmountPercent < 0 || this.form.coinAmountPercent > 100)
        ) {
          alert("กรุณาแก้ไขเปอร์เซ็นต์ MNC");
          return;
        }

        if (
          this.form.coinAmountFix &&
          (this.form.coinAmountFix < 0 ||
          convertBathToStangAndRoundTwoDecimal(this.form.coinAmountFix) > this.form.price)
        ) {
          alert("กรุณาแก้ไขการใช้ส่วนลด MNC");
          return;
        }

        if (this.form.hasAdvanceNotice === true) {
          if (
          this.form.advanceNoticeDuration > 0
          && 
          (
            isEmpty(this.form.advanceNoticeMessage)
            || isNil(this.form.advanceNoticeMessage)
          )
          ) {
            alert("กรุณาใส่ข้อความแจ้งเตือน");
            return;
          }

          if (this.form.advanceNoticeDuration < 1) {
            alert("กรุณาใส่จำนวนวันแจ้งเตือนล่วงหน้า");
            return;
          }
        }

        await this.updatePackage();
        this.$router.push({ name: "PackageListPage" });
      } catch (err) {
        if (
          err.response
          && err.response.status
          && err.response.status === 400
        ) {
          alert(err.response.data.message);
          console.error(err);
        } else {
          alert(err.message);
          console.error(err);
        }
      }
    },
    async updatePackage() {
      const { id } = this.$route.params;
      const {
        name,
        receiptName,
        detail,
        target,
        pricings,
        termsAndConditions,
        sellerTradePartyId,
        imageFile,
        thumbnailFile,
        projects,
        homes,
        isSecret,
        isExpireAfterAppointment,
        noteLabel,
        registrationForm,
        packageCollection,
        purchasingLimit,
        purchaseSuccessTitle,
        purchaseSuccessMessage,
        expiredAt,
        minimumQuantity,
        maximumQuantity,
        packageOptions,
        originalPrice,
        price,
        packageAlbums,
        coinAmountPercent,
        coinAmountFix,
        keywords,
        advanceNoticeDuration,
        advanceNoticeMessage,
        paymentCampaignIds,
        isNotSendReceipt
      } = this.form;

      const newPackageOptions = await this.setupPackageOptionsMultiplyPrice(packageOptions);
      const projectIds = projects.map(({ projectId }) => projectId);
      const homeIds= homes.map(({ home_id }) => home_id);
      const subpackageIds = packageCollection
        ? packageCollection.split(",").map(id => id.trim())
        : [];
      //PROBLEM : too many async await and Promise.all
      const registration_form = registrationForm ? {
        ...registrationForm,
        sections: await Promise.all(
          registrationForm.sections.map(async section => {
            return {
              ...section,
              inputs: await Promise.all(
                section.inputs.map(async input => {
                  return {
                    isRequired: input.isRequired,
                    prefillKey: input.prefillKey,
                    title: input.title,
                    type: input.type,
                    watermarkUrl: input.watermarkFile
                      ? await uploadPublicImage(
                          input.watermarkFile,
                          name,
                          "article"
                        )
                      : input.watermarkUrl
                      ? input.watermarkUrl
                      : null
                  };
                })
              )
            };
          })
        )
      } : null;

      const params = {
        name,
        receiptName,
        detail,
        target,
        pricings,
        termsAndConditions,
        sellerTradePartyId,
        projectIds: projectIds,
        homeIds,
        isSecret,
        isExpireAfterAppointment,
        noteLabel,
        registrationForm: registration_form,
        subpackageIds,
        purchasingLimit,
        purchaseSuccessTitle,
        purchaseSuccessMessage,
        expiredAt: toOptionalISOString(expiredAt),
        minimumQuantity: parseInt(minimumQuantity),
        maximumQuantity: parseInt(maximumQuantity),
        packageOptions: newPackageOptions,
        originalPrice: originalPrice !== null
          ? convertStangToBathAndRoundTwoDecimal(originalPrice)
          : null,
        packageAlbums: undefined,
        price: convertStangToBathAndRoundTwoDecimal(price),
        coinAmountPercent,
        coinAmountFix: convertStangToBathAndRoundTwoDecimal(coinAmountFix),
        tags: keywords,
        advanceNoticeDuration: parseInt(advanceNoticeDuration),
        advanceNoticeMessage,
        paymentCampaignIds,
        isNotSendReceipt
      };

      if (imageFile) {
        params.image = imageFile
      }

      if (packageAlbums && packageAlbums.length > 0) {
        const albumPack = packageAlbums.filter((album) => album !== this.imageUrl)

        if (albumPack && albumPack.length > 0) {
          params.packageAlbums = albumPack
        } else {
          params.packageAlbums = []
        }
      }

      if (thumbnailFile) {
        params.thumbnail = await uploadPublicImage(
          thumbnailFile,
          name,
          "article"
        );
      }

      const response =
        this.language === localization.TH
          ? await baanRueJaiClient.admin.subscriptions.recommend_packages.put(
              id,
              params
            )
          : await baanRueJaiClient.admin.subscriptions.recommend_packages.putLocalization(
              id,
              params,
              this.language
            );

      return response.data.result;
    },
    async handleClickRemove() {
      if (!confirm("ยืนยันการลบบริการ")) {
        return;
      }

      try {
        await this.removePackage();
        this.$router.push({ name: "PackageListPage" });
      } catch (err) {
        alert("เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง");
        console.error(err);
      }
    },
    async removePackage() {
      const { id } = this.$route.params;

      await baanRueJaiClient.admin.subscriptions.recommend_packages.delete(id);
    },
    handleClickDuplicate() {
      const { id } = this.$route.params;

      this.$router.push({ name: "PackageCreatePage", query: { id } });
    },
    handleClickExportRegistrationFormButton() {
      this.exportDialog.isShow = true;
    },
    async handleChangeLanguage() {
      const translationPackage = await this.setupLanguage();

      if (!translationPackage) return

      this.form = {
        ...this.form,
        target: translationPackage.target,
        noteLabel: translationPackage.note_label,
        purchaseSuccessTitle: translationPackage.purchase_success_title,
        purchaseSuccessMessage: translationPackage.purchase_success_message,
        name: translationPackage.name,
        detail: translationPackage.detail,
        termsAndConditions: translationPackage.terms_and_conditions,
        registrationForm: toCamelCaseObject(translationPackage.registration_form),
        language: this.language
      }
    },
    async setupLanguage() {
      const { id } = this.$route.params;

      try {
        const response = await baanRueJaiClient.admin.subscriptions.recommend_packages.getLanguage(
          id,
          this.language
        );

        return response.data.result;
      } catch (error) {
        alert("ไม่สามารถเปลี่ยนภาษาได้");
        console.error(error);
      }
    },
    handleSetupPricings() {
      if (this.form.hasOptionPackage && !isEmpty(this.form.services)) {
        const options = this.getOptions(this.form.services);

        this.setupPricings(options);
      } else {
        this.form.pricings = [];
      }
    },
    async handleConfirm(confirm) {
      if (!confirm) {
        this.exportDialog.isShow = false;
        return;
      }

      if (this.exportType === "xlsx") {
        await this.downloadExcel();
      } else [await this.downloadZip()];

      this.exportDialog.isShow = false;
      this.exportForm = [];
      this.exportType = "xlsx";
    },
    async downloadExcel() {
      const [from, to] = this.exportForm;

      if (!from || !to) {
        return;
      }

      const id = this.$route.params.id;

      const response = await baanRueJaiClient.admin.subscriptions.recommend_packages.getRegistrationFormsReport(
        id,
        this.exportQuery
      );

      const filename = `${this.form.name}${from.toFormat(
        "d/M/yyyy"
      )}-${to.toFormat("d/M/yyyy")}.xlsx`;
      const blob = new Blob([response.data]);

      this.downloadAsFile(filename, blob);
    },
    async downloadZip() {
      const [from, to] = this.exportForm;

      if (!from || !to) {
        return;
      }

      const id = this.$route.params.id;

      const response = await baanRueJaiClient.admin.subscriptions.subscribers.getPackageRegistrationFormsPdfsZip(
        id
      );

      const filename = `${this.form.name}${from.toFormat(
        "d/M/yyyy"
      )}-${to.toFormat("d/M/yyyy")}.zip`;
      const blob = new Blob([response.data]);

      this.downloadAsFile(filename, blob);
    },
    downloadAsFile(filename, blob) {
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = filename;
      link.click();
    },
    async handleClickDownloadReport() {
      const { id } = this.$route.params;

      try {
        const response = await baanRueJaiClient.admin.subscriptions.recommend_packages.getReport(
          id
        );

        const blob = new Blob([response.data]);
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = `report-active-subscribers-${id}.xlsx`;
        link.click();
      } catch(error) {
        // TODO: use alert message from response message backend
        alert("ไม่สามารถ Download Report ได้ เนื่องจากไม่มีข้อมูลหรือเกิดข้อผิดพลาด");
        console.error(error);
      }
    },
    async setupPackageOptionsDividePrice(packageOptions) {
      if(!packageOptions) return undefined

      packageOptions.forEach((packageOption) => {
        const serviceOriginalPrice = convertBathToStangAndRoundTwoDecimal(packageOption.service_original_price);
        const servicePrice = convertBathToStangAndRoundTwoDecimal(packageOption.service_price);

        packageOption.service_original_price = serviceOriginalPrice;
        packageOption.service_price = servicePrice;

        if (
          packageOption.service_appointment_prices
          && packageOption.service_appointment_prices.length > 0
        ) {
          packageOption.service_appointment_prices.map((appointmentPrice) => {
            const appointPrice = convertBathToStangAndRoundTwoDecimal(appointmentPrice.appoint_price);
            appointmentPrice.appoint_price = appointPrice;
          })
        }

        if (servicePrice === undefined && !packageOption.service_option_variants) {
          this.newServicePrices.push(packageOption.service_id);
        }

        if (packageOption.service_option_variants) {
          packageOption.service_option_variants.forEach((serviceOptionVariant) => {
            serviceOptionVariant.variants.forEach((variant) => {
              const price = convertBathToStangAndRoundTwoDecimal(variant.price);
              const originalPrice = convertBathToStangAndRoundTwoDecimal(variant.original_price);
              variant.price = price;
              variant.original_price = originalPrice;

              if (price === undefined) {
                this.newOptionVariantPrices.push(variant.id);
              }

              if (variant.appointment_prices && variant.appointment_prices.length > 0) {
                variant.appointment_prices.forEach((appointmentPrice) => {
                  const appointPrice = convertBathToStangAndRoundTwoDecimal(appointmentPrice.appoint_price);
                  appointmentPrice.appoint_price = appointPrice;
                })
              }
            })
          })
        }
      })

      return packageOptions
    },
    async setupPackageOptionsMultiplyPrice(packageOptionsDetail) {
      if (!packageOptionsDetail) return undefined;

      const packageOptions = packageOptionsDetail.map((packageOption) => {
        let serviceOptionVariants;
        let serviceAppointmentPrices;

        const servicePrice = convertStangToBathAndRoundTwoDecimal(packageOption.service_price)
        const serviceOriginalPrice = convertStangToBathAndRoundTwoDecimal(packageOption.service_original_price)

        if(
          packageOption.service_appointment_prices
          && packageOption.service_appointment_prices.length > 0
        ) {
          serviceAppointmentPrices = packageOption.service_appointment_prices.map(
            (serviceAppointmentPrice) => {
              const appointPrice = convertStangToBathAndRoundTwoDecimal(serviceAppointmentPrice.appoint_price)

              return {
                appoint_no: serviceAppointmentPrice.appoint_no,
                appoint_price: appointPrice
              };
            }
          );
        }

        if (packageOption.service_option_variants) {
          serviceOptionVariants = packageOption.service_option_variants.map(
            (optionVariant) => {
              const variants = optionVariant.variants.map((variant) => {
                const originalPrice = convertStangToBathAndRoundTwoDecimal(variant.original_price)
                const price = convertStangToBathAndRoundTwoDecimal(variant.price)

                const isEmptyIsNotSaleNewOption = this.newOptionVariantPrices
                  ? this.newOptionVariantPrices.some(
                      (newOptionVariant) => newOptionVariant === variant.id
                    )
                  : false;

                const isNotSale = price >= 0 && isEmptyIsNotSaleNewOption
                    ? false
                    : variant.is_not_sale;

                const appointmentPrices = variant.appointment_prices
                  && variant.appointment_prices.length > 0
                  ? variant.appointment_prices.map(
                    (appointmentPrice) => {
                      const appointPrice = convertStangToBathAndRoundTwoDecimal(appointmentPrice.appoint_price)

                      return {
                        appoint_no: appointmentPrice.appoint_no,
                        appoint_price: appointPrice
                      };
                    }
                  )
                  : null;

                return {
                  extra_option: variant.extra_option,
                  id: variant.id,
                  is_discount: variant.is_discount,
                  is_not_sale: isNotSale,
                  is_out_of_stock: variant.is_out_of_stock,
                  original_price: originalPrice,
                  price: price,
                  title: variant.title,
                  appointment_prices: appointmentPrices
                };
              });

              return {
                id: optionVariant.id,
                title: optionVariant.title,
                variants
              };
            }
          );
        }

        return {
          is_discount: packageOption.is_discount,
          is_not_sale: packageOption.is_not_sale,
          is_out_of_stock: packageOption.is_out_of_stock,
          service_extra_option: packageOption.service_extra_option,
          service_id: +packageOption.service_id,
          service_main_option: packageOption.service_main_option,
          service_option_variants: serviceOptionVariants,
          service_original_price: serviceOriginalPrice,
          service_price: servicePrice,
          service_title: packageOption.service_title,
          service_appointment_prices: serviceAppointmentPrices,
          is_appointment: packageOption.is_appointment
        };
      });

      return packageOptions;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";

.wrapper {
  padding: $space 0;
}

.editor {
  margin-bottom: $space;
}
</style>



// WEBPACK FOOTER //
// src/features/subscriptions/modules/packages/pages/PackageDetailPage.vue